import { useMemo } from 'react'
import { ArrowRight, Button, LottieCharacter } from '@astrid/components'
import ScoreIndicator from 'components/ScoreIndicator/ScoreIndicator'
import { SimpleWordScore } from 'store/services/Exercise'
import { StudyBuddyMood } from 'utils/types'

import styles from './WordsPracticePreview.module.scss'

type WordsPracticePreviewProps = {
  mood: StudyBuddyMood
  onStartClick: () => void
  words: SimpleWordScore[]
  title?: string
  isRegularProPro: boolean
}

const getScoreColor = (score: number) => {
  if (score >= 80) {
    return '#5DDFB1'
  }

  if (score < 50) {
    return '#F76988'
  }

  return '#ffdc4a'
}

const WordsPracticePreview: React.FC<WordsPracticePreviewProps> = ({
  mood,
  onStartClick,
  words,
  title,
  isRegularProPro
}) => {
  const areMoreThan3Words = words.length > 3

  const isLimitedSpace = useMemo(() => {
    return areMoreThan3Words && window.innerHeight < 700
  }, [areMoreThan3Words])

  return (
    <div className={styles.container}>
      <div className={styles.scroll}>
        <div className={`${styles.innerScroll} ${isLimitedSpace ? styles.compact : ''}`}>
          <div className={styles.character}>
            <LottieCharacter characterName={'Abbe'} mood={mood} changeCharacterMood={() => {}} />
          </div>
          <h1 className={styles.heading}>{title || "Let's Practice!"}</h1>
          <div className={styles.box}>
            {words.map((wordScore) => (
              <div key={wordScore.word} className={`${styles.row} ${areMoreThan3Words ? styles.smallMargin : ''}`}>
                {isRegularProPro && (
                  <div className={styles.col}>
                    <ScoreIndicator
                      value={wordScore.score}
                      sizeInPx={areMoreThan3Words ? 38 : 42}
                      strokeWidthInPx={areMoreThan3Words ? 6 : 7}
                      fontSize={areMoreThan3Words ? '12px' : wordScore.score === 100 ? '13px' : '16px'}
                      colorsThresholds={{
                        LOW: 50,
                        HIGH: 80
                      }}
                    />
                  </div>
                )}
                <div className={styles.wordContainer}>
                  <div
                    className={`${styles.word} ${wordScore.word.length > 14 ? styles.long : ''}`}
                    style={{
                      color: isRegularProPro ? getScoreColor(wordScore.score) : '#000'
                    }}
                  >
                    {wordScore.word}
                  </div>
                </div>
                <div className={styles.filler} />
              </div>
            ))}
          </div>
          <Button
            color="light-blue"
            className={styles.startButton}
            onClick={onStartClick}
            aria-label={'Start practice'}
          >
            <ArrowRight />
          </Button>
        </div>
      </div>
    </div>
  )
}

export default WordsPracticePreview
